import {of} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';

import * as Api from './api';
import * as Actions from './actions';

const fetch = action$ =>
    action$.ofType(Actions.fetchReports.type).mergeMap(({payload}) =>
        Api.fetchReports(
            payload.institutionId,
            payload.kinds,
            payload.from,
            payload.to,
            payload.location,
            payload.childIds,
            payload.reporterIds,
            payload.cursor,
        )
            .flatMap(response => [Actions.fetchReportsSuccess.action(response, payload.cursor !== null)])
            .catch(e => of(Actions.fetchReportsFailed.action(e))),
    );

const initialFetch = action$ =>
    action$.ofType(Actions.initialFetchReports.type).mergeMap(({payload}) =>
        Api.fetchReports(
            payload.institutionId,
            payload.kinds,
            payload.from,
            payload.to,
            payload.location,
            payload.childIds,
            payload.reporterIds,
            payload.cursor,
        )
            .flatMap(response => [Actions.initialFetchReportsSuccess.action(response, payload.cursor !== null)])
            .catch(e => of(Actions.initialFetchReportsFailed.action(e))),
    );

export default combineEpics(fetch, initialFetch);
